import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserModels } from '@share-models';
import type { AuthModel } from '@ui';

export const UserActions = createActionGroup({
  source: 'USER',
  events: {
    'Reset to Initial state': emptyProps(),
    'Get user profile': emptyProps(),
    'Get user profile success': props<{ profile: UserModels.UserDocument }>(),
    'Get user profile fail': emptyProps(),
    'Login success': props<{
      data: AuthModel.Events.LoginSuccessEventData;
      redirectUrl?: string | undefined;
    }>(),
  },
});
